module.exports = __webpack_public_path__ + "img/58.62f23d72.png";